export const formatMillions = (
	amount: number,
	locale: string,
	fractionDigits: number,
): string =>
	new Intl.NumberFormat(locale, {
		minimumFractionDigits: fractionDigits,
		maximumFractionDigits: fractionDigits,
	}).format(amount / 1_000_000);
